/*
 * The audience gate for components (SPEC decision 23): the pure rules live in `audience.ts`; these hooks read `GET /me`.
 */
import { useQuery } from '@tanstack/react-query';
import { getMe } from '@/api/endpoints';
import { qk } from '@/api/queryKeys';
import { seesProviders, wordingFor } from './audience';

/**
 * The gate for components: reads the `GET /me` the shell already loads and never fetches it itself (so it is safe on
 * signed-out pages). False until the role is known, so provider names never flash before it.
 */
export function useSeesProviders(): boolean {
  const me = useQuery({ queryKey: qk.me, queryFn: getMe, enabled: false });
  return seesProviders(me.data);
}

/** For components: rewords API text unless the viewer is a platform operator. */
export function useWording(): (text: string) => string {
  return wordingFor(useSeesProviders());
}
